export const SET_LANGUAGE = 'SET_LANGUAGE'
export const GET_LANGUAGES = 'GET_LANGUAGES'
export const GET_LANGUAGES_ERROR = 'GET_LANGUAGES_ERROR'
export const GET_LANGUAGES_SUCCESS = 'GET_LANGUAGES_SUCCESS'
